/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import {
    Paper,
    Stack,
    Typography,
    Chip,
    ToggleButtonGroup,
    ToggleButton,
    Button,
    Divider,
    MenuItem,
    FormControl,
    InputLabel,
    Select,
} from '@mui/material';
import { Refresh, PlayArrow } from '@mui/icons-material';
import { populationFilterOptions } from 'features/lab2/constants/filterOptions';

const themeColor = '#002755';
const ageRanges = [
    { label: '전체', value: 'all' },
    { label: '20대', value: '20' },
    { label: '30대', value: '30' },
    { label: '40대', value: '40' },
    { label: '50대', value: '50' },
    { label: '60대 이상', value: '60' },
];

const PopulationControlPanel = ({
    currentFilter,
    onFilterChange,
    selectedAge,
    onAgeChange,
    onSearch,
    onReset,
}) => {
    const currentFilterLabel =
        populationFilterOptions.find((opt) => opt.value === currentFilter?.value)?.label || '인구수';

    return (
        <Stack spacing={2.5}>
            <Paper
                elevation={0}
                sx={{
                    p: 3,
                    borderRadius: 3,
                    border: '1px solid #e3e7f0',
                    background: '#fff',
                }}
            >
                <Stack spacing={2}>
                    <Stack spacing={0.5}>
                        <Typography variant="subtitle2" color="text.secondary">
                            지표 선택
                        </Typography>
                        <FormControl size="small" fullWidth>
                            <InputLabel>지표</InputLabel>
                            <Select
                                label="지표"
                                value={currentFilter?.value || populationFilterOptions[0].value}
                                onChange={(e) => onFilterChange?.(e.target.value)}
                            >
                                {populationFilterOptions.map((opt) => (
                                    <MenuItem key={opt.value} value={opt.value}>
                                        {opt.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Stack>

                    <Divider />

                    <Stack spacing={1}>
                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: themeColor }}>
                                인구 정보 검색
                            </Typography>
                            <Chip label={currentFilterLabel} size="small" color="primary" />
                        </Stack>
                        <Typography variant="body2" color="text.secondary">
                            연령대별 인구 분포를 확인하세요.
                        </Typography>
                    </Stack>

                    <Stack spacing={1}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                            연령대 선택
                        </Typography>
                        <ToggleButtonGroup
                            value={selectedAge}
                            exclusive
                            onChange={(_, value) => {
                                if (value) onAgeChange?.(value);
                            }}
                            sx={{
                                flexWrap: 'wrap',
                                '& .MuiToggleButton-root': {
                                    flex: '1 1 45%',
                                    m: 0.5,
                                    borderRadius: 2,
                                    borderColor: '#cfd4e6',
                                },
                            }}
                        >
                            {ageRanges.map((range) => (
                                <ToggleButton key={range.value} value={range.value}>
                                    {range.label}
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    </Stack>

                    {/* <Stack direction="row" spacing={1.5}>
                        <Button
                            variant="contained"
                            startIcon={<PlayArrow />}
                            onClick={onSearch}
                            sx={{ flex: 1, bgcolor: themeColor, '&:hover': { bgcolor: '#001b3d' }, fontWeight: 700 }}
                        >
                            검색
                        </Button>
                        <Button variant="outlined" startIcon={<Refresh />} onClick={onReset} sx={{ flex: 1 }}>
                            초기화
                        </Button>
                    </Stack> */}
                </Stack>
            </Paper>
        </Stack>
    );
};

PopulationControlPanel.propTypes = {
    currentFilter: PropTypes.shape({
        value: PropTypes.string,
    }),
    onFilterChange: PropTypes.func,
    selectedAge: PropTypes.string.isRequired,
    onAgeChange: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
};

export default PopulationControlPanel;
